import {
    FETCH_PORTFOLIO_DETAILS_SUCCESS,
    FETCH_PORTFOLIO_DETAILS_FAILURE,
    SEARCH_PORTFOLIO_SUCCESS,
    SEARCH_PORTFOLIO_FAILURE,
    FETCH_RISK_LEVELS_SUCCESS,
    FETCH_RISK_LEVELS_FAILURE,
    FETCH_BUSINESS_SEGMENT_SUCCESS,
    FETCH_BUSINESS_SEGMENT_FAILURE,
    FETCH_LEGALCONSTITUTION_SUCCESS,
    FETCH_LEGALCONSTITUTION_FAILURE,
    FETCH_CASE_STATUS_SUCCESS,
    FETCH_CASE_STATUS_FAILURE,
    FETCH_RISK_TREND_SUCCESS,
    FETCH_RISK_TREND_FAILURE,
    FETCH_PRODUCT_NAME_FILTER_LIST_SUCCESS,
    FETCH_PRODUCT_NAME_FILTER_LIST_FAILURE,
    FETCH_PRODUCT_TYPE_DETAILS_SUCCESS,
    FETCH_PRODUCT_TYPE_DETAILS_FAILURE,
    PORTFOLIO_APPLIED_FILTERS,
    FETCH_CUG_CORPORATE_DATA,
    FETCH_CUG_CORPORATE_DATA_SUCCESS,
    FETCH_CUG_CORPORATE_DATA_FAILURE,
    FETCH_CASE_TYPE_SUCCESS,
    FETCH_CASE_TYPE_FAILURE,
    GET_SELECTED_COMPANY_NAME
} from './action';
// import { SEARCH_RESULTS_FAILURE } from '../../../components/ReusableComponents/AutoSuggest/action'
const initialState = {
    portfolioList: [],
    portfolioListFailure: [],
    riskLevelSuccess: [],
    riskLevelFailure: [],
    riskTrendSuccess: [],
    riskTrendFailure: [],
    legalConstitutionSuccess: [],
    legalConstitutionFailure: [],
    businessSegmentSuccess: [],
    businessSegmentFailure: [],
    caseStatusSuccess: [],
    caseStatusFailure: [],
    productNameListSuccess: [],
    productNameListFailure: [],
    productTypeDetails: [],
    productTypeDetailsFailure: [],
    portfolioFilters: [],
    dashboardFilters: [],
    cugCorporateDataSuccess: [],
    cugCorporateDataFailure:[],
    caseTypeSuccess:[],
    caseTypeFailure:[],
    setSelectedCompanyName:{}
};
const portFolioReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_PORTFOLIO_DETAILS_SUCCESS:
            return state = {
                ...state,
                portfolioList: action.data
            }
        case FETCH_PORTFOLIO_DETAILS_FAILURE:
            return state = {
                ...state,
                portfolioListFailure: action.data
            }
        case SEARCH_PORTFOLIO_SUCCESS:
            return state = {
                ...state,
                portfolioList: action.data
            }
        case SEARCH_PORTFOLIO_FAILURE:
            return state = {
                ...state,
                portfolioListFailure: action.data
            }
        case FETCH_RISK_LEVELS_SUCCESS:
            return state = {
                ...state,
                riskLevelSuccess: action.data
            }
        case FETCH_RISK_LEVELS_FAILURE:
            return state = {
                ...state,
                riskLevelFailure: action.data
            }
        case FETCH_BUSINESS_SEGMENT_SUCCESS:
            return state = {
                ...state,
                businessSegmentSuccess: action.data
            }
        case FETCH_BUSINESS_SEGMENT_FAILURE:
            return state = {
                ...state,
                businessSegmentFailure: action.data
            }
        case FETCH_LEGALCONSTITUTION_SUCCESS:
            return state = {
                ...state,
                legalConstitutionSuccess: action.data
            }
        case FETCH_LEGALCONSTITUTION_FAILURE:
            return state = {
                ...state,
                legalConstitutionFailure: action.data
            }
        case FETCH_CASE_STATUS_SUCCESS:
            return state = {
                ...state,
                caseStatusSuccess: action.data
            }
        case FETCH_CASE_STATUS_FAILURE:
            return state = {
                ...state,
                caseStatusFailure: action.data
            }
        case FETCH_RISK_TREND_SUCCESS:
            return state = {
                ...state,
                riskTrendSuccess: action.data
            }
        case FETCH_RISK_TREND_FAILURE:
            return state = {
                ...state,
                riskTrendFailure: action.data
            }
        case FETCH_PRODUCT_NAME_FILTER_LIST_SUCCESS:
            return state = {
                ...state,
                productNameListSuccess: action.data
            }
        case FETCH_PRODUCT_NAME_FILTER_LIST_FAILURE:
            return state = {
                ...state,
                productNameListFailure: action.data
            }
        case FETCH_PRODUCT_TYPE_DETAILS_SUCCESS:
            return state = {
                ...state,
                productTypeDetails: action.data
            }
        case FETCH_PRODUCT_TYPE_DETAILS_FAILURE:
            return state = {
                ...state,
                productTypeDetailsFailure: action.data
            }
        case PORTFOLIO_APPLIED_FILTERS:
            return state = {
                ...state,
                portfolioFilters: action.data
            }
        case FETCH_CUG_CORPORATE_DATA_SUCCESS:
            return state = {
                ...state,
                cugCorporateDataSuccess: action.data
            }
        case FETCH_CUG_CORPORATE_DATA_FAILURE:
            return state = {
                ...state,
                cugCorporateDataFailure: action.data
            }
        case FETCH_CASE_TYPE_SUCCESS:
            return state = {
                ...state,
                caseTypeSuccess: action.data
            }
        case FETCH_CASE_TYPE_FAILURE:
            return state = {
                ...state,
                caseTypeFailure: action.data
            }
        case GET_SELECTED_COMPANY_NAME:
            return state = {
                ...state,
                setSelectedCompanyName: action.data
            }
        default:
            return state
    }
}
export default portFolioReducer;